import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { WhiteText } from './CommonStyles';

interface Props{
    message: string;
}
export class Loader extends React.Component<Props>{
    public render() {
        return (<LoaderWrapper>
            <Message> {this.props.message} </Message>
            <Container>
                <LoadingCircle style={{animationDelay:"0s"}}/>
                <LoadingCircle style={{animationDelay:"0.25s"}}/>
                <LoadingCircle style={{animationDelay:"0.50s"}}/>
                <LoadingCircle style={{animationDelay:"0.75s"}}/>
                <LoadingCircle style={{animationDelay:"1s"}}/>
                <LoadingCircle style={{animationDelay:"1.25s"}}/>
                <LoadingCircle style={{animationDelay:"1.50s"}}/>
                <LoadingCircle style={{animationDelay:"1.75s"}}/>
                <LoadingCircle style={{animationDelay:"2s"}}/>
            </Container>
        </LoaderWrapper>);
    };
}
const Message = styled(WhiteText)`
    position:absolute;
    width:100%;
    text-align:center;
    font-size:10vh;
    bottom: 16vh;
`;
const Container = styled.div`
    bottom:80vh;
    width:100%;
    display:flex;
    

    justify-content: space-evenly;
`;
const move = keyframes`
  0% {
    border: none;
  }

  50% {
    border: #00A3FF solid 4px;
  }

  100% {
    border: none;
  }
`;
const LoaderWrapper = styled.div`
    width:100%;
    height:100vh;
    background-color:black;
    z-index:5;
    position:relative;

`;
const LoadingCircle = styled.div`
    animation: ${move} 2s linear infinite;
    animation-timing-function:step-start;
    transform:translateY(90vh);

    width:2vh;
    height:2vh;
`;


// WEBPACK FOOTER //
// ./src/Components/Loader.tsx